import React from 'react';
import Select, { components } from 'react-select';

const Filter = (props) => {
    const { options, onChange } = props;

    const DropdownIndicator = (
        props: ElementConfig<typeof components.DropdownIndicator>
    ) => (
        <components.DropdownIndicator {...props}>
            <div>
                <i className="icon icon-arrow_filter"></i>
            </div>
        </components.DropdownIndicator>
    );

    const colourStyles = {
        control: (styles, state) => ({
            ...styles,
            backgroundColor: 'black',
            boxShadow: 'black !important',
            '&:hover': {
                boxShadow: 'black !important',
            },
        }),
        menu: (styles) => ({ ...styles, backgroundColor: 'black' }),
        option: (styles, { isDisabled, isFocused, menu }) => {
            return {
                ...styles,
                backgroundColor: isFocused ? 'white' : 'black',
                color: isFocused ? 'black' : 'white',
                borderColor: isFocused ? 'black' : 'white',
                cursor: isDisabled ? 'not-allowed' : 'default',
            };
        },
    };

    return (
        <div className="dropdown-container">
            <Select
                placeholder="Filter by theme"
                components={{ DropdownIndicator }}
                options={options}
                onChange={onChange}
                isClearable
                isSearchable={false}
                className="react-select-container"
                classNamePrefix="react-select"
                styles={colourStyles}
            />
        </div>
    );
};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/Filter.jsx